import React from "react";
import ProjectFormContent from "./components/ProjectFormContent";
import { ProjectFormProvider } from "./context/ProjectFormContext";

type Props = {
  onSubmit: (data: any) => Promise<any>;
  onReset: () => void;
  project?: any;
  projectError?: any;
  defaultValuesForm?: any;
  isSubmitting?: boolean;
};

const ProjectForm: React.FC<Props> = ({
  onSubmit,
  onReset,
  project,
  projectError,
  isSubmitting = false,
  defaultValuesForm = {},
}) => {
  return (
    <ProjectFormProvider
      project={project}
      isSubmitting={isSubmitting}
      projectError={projectError}
      defaultValuesForm={defaultValuesForm}
    >
      <ProjectFormContent onSubmit={onSubmit} onReset={onReset} />
    </ProjectFormProvider>
  );
};

export default ProjectForm;
